import { render, staticRenderFns } from "./modelsList.vue?vue&type=template&id=4e9775fa"
import script from "./modelsList.vue?vue&type=script&lang=js"
export * from "./modelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports